namespace TabAurous.Inventory {
    export namespace CertificationIssueSelectItemsService {
        export const baseUrl = 'Inventory/CertificationIssueSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<CertificationIssueItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Inventory/CertificationIssueSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CertificationIssueSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
